import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "../i18n/I18nContext";
import { listUniforms, addStock } from "../services/uniform";

const StockUniformesLayer = () => {
  const { t } = useTranslation();
  const [uniforms, setUniforms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [target, setTarget] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [saving, setSaving] = useState(false);

  const fetchUniforms = () => {
    setLoading(true);
    listUniforms()
      .then((resp) => setUniforms(resp.data || []))
      .catch(() => toast.error(t("artigo.error.load")))
      .finally(() => setLoading(false));
  };

  useEffect(fetchUniforms, [t]);

  const openModal = (uniform) => {
    setTarget(uniform);
    setQuantity("");
  };
  const closeModal = () => setTarget(null);

  const handleAddStock = async () => {
    const qty = Number(quantity);
    if (!qty || qty <= 0) {
      toast.error(t("stock.error.invalidQuantity"));
      return;
    }
    setSaving(true);
    try {
      await addStock(target.id, qty);
      toast.success(t("stock.success.added"));
      closeModal();
      fetchUniforms();
    } catch (err) {
      toast.error(err?.response?.data?.error || t("stock.error.add"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className='row gy-4'>
      <ToastContainer />

      <div className='col-12'>
        <div className='card radius-12'>
          <div className='card-body'>
            <h6 className='mb-16'>{t("stock.breadcrumb")}</h6>
            {loading ? (
              <div className='text-center py-40'>{t("global.loading")}</div>
            ) : uniforms.length === 0 ? (
              <div className='alert alert-info mb-0'>{t("artigo.hint.noArticles")}</div>
            ) : (
              <div className='table-responsive'>
                <table className='table bordered-table mb-0'>
                  <thead>
                    <tr>
                      <th>{t("artigo.field.name")}</th>
                      <th>{t("artigo.field.gender")}</th>
                      <th>{t("artigo.field.size")}</th>
                      <th>{t("artigo.field.color")}</th>
                      <th>{t("artigo.col.available")}</th>
                      <th>{t("artigo.col.sold")}</th>
                      <th>{t("turma.col.actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uniforms.map((u) => (
                      <tr key={u.id}>
                        <td>{u.artigo}</td>
                        <td>{u.genero}</td>
                        <td>{u.tamanho}</td>
                        <td>{u.cor || "-"}</td>
                        <td>{u.quantidade || 0}</td>
                        <td>{u.quantidadeVendida || 0}</td>
                        <td>
                          <button
                            type='button'
                            className='btn btn-outline-primary-600 btn-sm d-flex align-items-center gap-1'
                            onClick={() => openModal(u)}
                          >
                            <Icon icon='mdi:package-up' />
                            {t("stock.action.addStock")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {target && (
        <div className='modal show d-block' style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h6 className='mb-0'>
                  {t("stock.action.addStock")} — {target.artigo}
                </h6>
                <button type='button' className='btn-close' onClick={closeModal} />
              </div>
              <div className='modal-body'>
                <label className='form-label'>{t("stock.field.quantityToAdd")}</label>
                <div className="icon-field">
                  <span className="icon">
                    <Icon icon="solar:box-minimalistic-outline" />
                  </span>
                  <input type='number' min='1' className='form-control' value={quantity} onChange={(e) => setQuantity(e.target.value)} autoFocus />
                </div>
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-outline-secondary' onClick={closeModal}>
                  {t("global.cancel")}
                </button>
                <button type='button' className='btn btn-primary-600' onClick={handleAddStock} disabled={saving}>
                  {saving ? t("global.loading") : (<><i className='ri-check-line' /> {t("global.confirm")}</>)}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StockUniformesLayer;
